import {MenuItem} from 'src/app/app.constants';
import {RolePermissions, RolePermissionValue} from 'src/app/core/model/role';

export const getRolePermissionByKey = (rolePermissions: RolePermissions, optionKey: string): RolePermissionValue => {
  if (!optionKey) throw new Error('Option key is required');
  if (!rolePermissions) throw new Error('Role permissions is required');
  if (typeof optionKey !== 'string') throw new Error('Option key must be a string');

  const keys = optionKey.split('.');
  let permissionObj = rolePermissions;
  for (const key of keys) {
    if (permissionObj && key in permissionObj) {
      permissionObj = permissionObj[key];
    } else {
      permissionObj = undefined;
      break;
    }
  }
  return permissionObj as unknown as RolePermissionValue;
};

export const getMenuItemsByRole = (rolePermissions: RolePermissions, menuItems: MenuItem[]): MenuItem[] => {
  if (!rolePermissions) throw new Error('Role permissions is required');
  return menuItems.filter(
    item => !item.rolePermissionKey || getRolePermissionByKey(rolePermissions, item.rolePermissionKey)?.active
  );
};
